const AccountCategory = ({ formik, showEditIcon, isDisabled }) => {
  const { values, handleChange, touched, errors } = formik;
  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">
        Account Category*
      </h2>
      <div className="grid grid-cols-12 gap-[8px]">
        <div className="col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-4">
          <select
            disabled={!showEditIcon && isDisabled}
            name="accountCategory.category"
            value={values?.accountCategory?.category}
            onChange={handleChange}
            className={`rounded-[6px] p-2 border transition-all duration-500 cursor-pointer focus:border-primary-500 placeholder:text-secondry-600 w-full h-[57px] bg-[right_8px_center] ${
              Boolean(errors?.accountCategory?.category) &&
              !values?.accountCategory?.category
                ? "border-orange-500 bg-orange-50 bg-orange-50"
                : "border-primary-50 bg-primary-50 focus-within:border-primary-500"
            }`}
          >
            <option value="" disabled>
              Select a category
            </option>
            <option value="category_a">A</option>
            <option value="category_b">B</option>
            <option value="category_c">C</option>
            <option value="category_d">D</option>
            <option value="category_e">E</option>
          </select>
        </div>
      </div>
      {touched?.accountCategory?.category &&
      Boolean(errors?.accountCategory?.category) ? (
        <div className="text-orange-800 text-[11px] uppercase mt-1 font-medium">
          {errors?.accountCategory?.category}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default AccountCategory;
